export default __webpack_public_path__ + "static/media/report.7e26f398.png";